import { render, staticRenderFns } from "./ServicesEmpowering.vue?vue&type=template&id=331a61ab&scoped=true"
import script from "./ServicesEmpowering.vue?vue&type=script&lang=js"
export * from "./ServicesEmpowering.vue?vue&type=script&lang=js"
import style0 from "./ServicesEmpowering.vue?vue&type=style&index=0&id=331a61ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a61ab",
  null
  
)

export default component.exports